
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/real-estate-history-louisiana-purchase",
      function () {
        return require("private-next-pages/articles/real-estate-history-louisiana-purchase.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/real-estate-history-louisiana-purchase"])
      });
    }
  